const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

async function Main(file) {
  const Base64String = await toBase64(file);
  console.log(Base64String);
  return Base64String;
}

export default Main;
